<template>
    <div class="set-transcoding-form">
        <div class="form-checkbox">
            <input id="transcoding_check" :checked="generalUpload" :disabled="waitMediaContent"
                   type="checkbox"
                   @input="handleCheck">
            <label for="transcoding_check"></label>
            <span :class="['transcoding_check-label', waitMediaContent ? 'disabled':'']">
                {{
                    $t('words.transcoding')
                }}
            </span>
        </div>
        <div v-if="!waitMediaContent" class="set-transcoding-form-desc">
            <p class="txt-desc">- {{ $t('words.upload_transcoding_desc_1_1') }}</p>
            <p class="txt-desc">- {{ $t('words.upload_transcoding_desc_1_2') }}</p>
        </div>
        <div v-else class="set-transcoding-form-desc">
            <p class="txt-desc">- {{ $t('words.upload_transcoding_desc_2_1') }}</p>
            <p class="txt-desc">- {{ $t('words.upload_transcoding_desc_2_2') }}</p>
            <p class="txt-desc">- {{ $t('words.upload_transcoding_desc_2_3') }}</p>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
    name: 'SetTranscoding',
    props: {
        waitMediaContent: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapGetters('media_contents_upload', ['generalUpload']),
    },
    methods: {
        ...mapMutations({
            setGeneralUpload: 'media_contents_upload/setGeneralUpload',
        }),
        handleCheck() {
            this.setGeneralUpload(!this.generalUpload);
        },
    },
};
</script>
